import { Col } from "@commonlibs";
import { alpha } from "@commonlibs";
import styled, { css } from "styled-components";

export const NothingToShowRoot = styled(Col)(
    ({ theme }) => css`
        padding: ${theme.spacing["5"]};
        flex: 1;
        align-items: center;
        justify-content: center;
        background: ${alpha(theme.palette.lavender, 0.32)};
        border-radius: ${theme.borderRadius};
    `,
);
